<template>
  <div
    class="company_container"
    :class="pclass"
    sm="6"
    md="6"
    v-if="item !== null && typeof item !== 'undefined'"
  >
    <div class="img_box">
      <img
        :src="imageURL"
        alt="company"
        v-if="imageURL !== null && imageURL !== ''"
      />
      <img :src="companyNoImage" alt="No thumnail of company" v-else />
    </div>
    <div class="widget-bottom">
      <div class="company-name">
        {{ getCompanyName }}
      </div>
      <div class="img-description">
        <div class="logo_box">
          <img :src="companyURL" alt="logo" v-if="companyURL !== null" />
          <img :src="companyNoImage" alt="None thumnail of company" v-else />
        </div>
        <div class="box-company">
          <div
            class="company-info"
            v-html="
              item.information !== null && item.information.business_content
                ? item.information.business_content
                : ''
            "
          ></div>
          <span
            >{{
              $t('company-detail.title.company-information.office-location', {
                split: '/'
              })
            }}:
          </span>
          <div
            class="company-address"
            v-html="
              item.information !== null && item.information.office_location
                ? item.information.office_location
                : ''
            "
          ></div>
        </div>
      </div>

      <div class="box-button">
        <div class="btn-left">
          <v-btn
            class="com_btn"
            depressed
            color="#E8320D"
            @click="postApplicantLogAndOpen"
            v-if="checkListCompanyDisplay"
          >
            <v-icon dark left>mdi-eye-outline</v-icon>
            {{ $t('component.button-detail', { split: '/' }) }}
          </v-btn>
        </div>
        <div class="btn-right">
          <v-btn
            depressed
            class="add-favorite-1"
            @click="
              removeFromFavorite(
                item.information !== null &&
                  typeof item.information.exhibiting_company_id !== 'undefined'
                  ? item.information.exhibiting_company_id
                  : item.id
              )
            "
            >{{
              $t('company-detail.button-remove-from-favorite-company', {
                split: '/'
              })
            }}</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { COMPANY_SCREEN_ID, PAGE_VIEW } from '@/common/constants';
import CompanyNoImage from '@/assets/image/company-no-image.jpg';
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
export default {
  data() {
    return {
      imageURL: null,
      companyURL: null,

      companyNoImage: CompanyNoImage,

      onClick: false
    };
  },
  name: 'CompanyCardFavorite',
  props: {
    item: {
      type: Object
    },

    pclass: {
      type: String
    }
  },

  watch: {},

  methods: {
    getDateFromUTC() {
      const timeZoneFilter = this.c_time_zone.filter(
        (timezone) => timezone.id == this.m_event.time_zone
      );

      if (timeZoneFilter.length > 0) {
        return moment(new Date())
          .tz(timeZoneFilter[0].time_zone_code)
          .format('YYYY-MM-DD');
      }
    },
    getDateTimeFromUTC() {
      const timeZoneFilter = this.c_time_zone.filter(
        (timezone) => timezone.id == this.m_event.time_zone
      );

      if (timeZoneFilter.length > 0) {
        return moment(new Date())
          .tz(timeZoneFilter[0].time_zone_code)
          .format('YYYY-MM-DD HH:mm:ss');
      }
    },
    checkDisplayListCompany(fromData, toData) {
      const timeZoneFilter = this.c_time_zone.filter(
        (timezone) => timezone.id == this.m_event.time_zone
      );

      if (timeZoneFilter.length > 0) {
        const dateFrom = moment
          .utc(fromData)
          .tz(timeZoneFilter[0].time_zone_code)
          .format('YYYY-MM-DD HH:mm:ss');

        const dateTo = moment
          .utc(toData)
          .tz(timeZoneFilter[0].time_zone_code)
          .format('YYYY-MM-DD HH:mm:ss');

        const now = this.getDateTimeFromUTC();

        if (now < dateFrom || now > dateTo) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    removeFromFavorite(exhibiting_company_id) {
      this.favoriteStatus = 'like';
      this.$store.dispatch('actionToFavorite', {
        exhibiting_company_id
      });
    },

    postApplicantLogAndOpen() {
      // create log applicant
      const data = {
        exhibiting_company_id: this.item.id,
        screen_id: COMPANY_SCREEN_ID,
        action: PAGE_VIEW
      };
      this.$store.dispatch('postApplicantLog', { data });
      this.$router.push('list-company' + '/' + this.item.id + '/detail');
    }
  },

  created() {
    if (this.item !== null && typeof this.item !== 'undefined') {
      const { information } = this.item;
      if (information !== null && typeof information !== 'undefined') {
        this.imageURL =
          this.item.information.thumbnail !== null
            ? this.item.information.thumbnail
            : null;
        this.companyURL =
          this.item.information.company_logo !== null
            ? this.item.information.company_logo
            : null;
      }
    }
  },

  computed: {
    ...mapGetters({
      favoriteCompany: 'getFavoriteCompanyData'
    }),
    getCompanyName() {
      if (
        this.item.information !== null &&
        this.item.information.complete_flag === 1
      ) {
        return this.item.information !== null
          ? this.item.information.company_name
          : '';
      } else {
        return this.item !== null ? this.item.company_name : '';
      }
    },
    checkListCompanyDisplay: function () {
      if (this.m_event !== null) {
        const {
          company_publicizing_period_from,
          company_publicizing_period_to
        } = this.m_event;
        if (
          company_publicizing_period_from !== null &&
          company_publicizing_period_to !== null
        ) {
          return this.checkDisplayListCompany(
            company_publicizing_period_from,
            company_publicizing_period_to
          );
        }
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../style/devices.scss';
.company_container {
  background: #f0f7fd;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  width: 100%;
  height: 340px;
  .img_box {
    overflow: hidden;
    position: relative;
    img {
      width: 100%;

      //center alignment
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
    .label-favorite-company {
      position: absolute;
      background: #ff7a00 !important;
      border-radius: 19px;
      color: #fff;

      right: 17px;
      top: 17px;
      text-transform: unset;
    }
  }

  .widget-bottom {
    display: flex;
    flex-direction: column;
    padding: 21px;
    position: relative;
    .company-name {
      font-weight: 600;
      margin-bottom: 0.8rem;
    }
    .img-description {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: row;

      .logo_box {
        width: 121px;
        min-width: 121px;
        height: 121px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

        position: relative;
        img {
          height: 100%;
          width: 100%;
        }
      }

      .box-company {
        white-space: pre-line;
        padding-left: 20px;
        width: 100%;
        word-break: break-word;
        .companys-name {
          font-weight: 600;
        }
        .company-info {
          max-height: 115px;
          height: 115px;
          margin-bottom: 10px;
          text-align: left !important;
          letter-spacing: 2px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 5; /* number of lines to show */
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        span {
          font-weight: bold;
        }
        .company-address {
          display: flex;
          margin-top: 10px;

          height: 60px;
          min-height: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 20px;
          -webkit-line-clamp: 3;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
      }
    }

    .box-button {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: row;
      margin-top: 20px;

      .btn-left {
        .com_btn {
          text-transform: unset;
          color: #fff;
          width: 100%;
          border-radius: 8px;
        }
      }
      .btn-right {
        .add-favorite-1 {
          background: #f0f7fd;
          border: 1.5px solid #e8320d;
          box-sizing: border-box;
          border-radius: 8px;
          color: #e8320d;
          text-transform: unset;
        }

        .add-favorite-2 {
          background: #e8320d;
          border: 1.5px solid #e8320d;
          box-sizing: border-box;
          border-radius: 8px;
          color: #fff;
          text-transform: unset;
        }

        .add-favorite-3 {
          border: 1.5px solid #00a2ff;
          box-sizing: border-box;
          border-radius: 8px;
          color: #00a2ff;
          text-transform: unset;
        }
      }
    }
  }
}

@media only screen and (max-width: 320px) {
  .label-favorite-company {
    right: 7px !important;
    width: 235px;
  }
}
@include small-mobile {
  .com_btn,
  .add-favorite-1 {
    font-size: 0.58rem !important;
  }
}

@include mobile {
  .company_card {
    width: 100% !important;
    margin-bottom: 32px !important;
    height: auto;
    .img_box {
      .label-favorite-company {
        font-size: 12px;
      }
    }

    .img-description {
      .logo_box {
        width: 80px !important;
        min-width: 80px !important;
        height: 80px !important;
      }

      .box-company {
        padding-left: 20px;
        .company-name {
          font-weight: 600;
        }
        .company-info {
          height: 64px;
          line-height: 120%;
          white-space: pre-wrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .box-button {
      display: flex;
      justify-content: flex-start !important;
      align-items: flex-start !important;
      flex-direction: column !important;

      .btn-left {
        width: 100%;
        .com_btn {
          width: 100% !important;
          font-size: 0.76rem;
        }
      }
      .btn-right {
        width: 100%;
        .add-favorite-3,
        .add-favorite-2,
        .add-favorite-1 {
          margin-top: 20px;
          font-size: 0.76rem;
          width: 100% !important;
        }
      }
    }
  }
}

@include laptop {
  .company_card {
    margin-bottom: 32px !important;
    height: auto;

    .img-description {
      .logo_box {
        width: 80px !important;
        min-width: 80px !important;
        height: 80px !important;
      }

      .box-company {
        padding-left: 20px;
        .company-name {
          font-weight: 600;
        }
        .company-info {
          height: 64px;
          line-height: 120%;
          white-space: pre-wrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .box-button {
      display: flex;
      justify-content: flex-start !important;
      align-items: flex-start !important;
      flex-direction: column !important;

      .btn-left {
        width: 100%;
        .com_btn {
          width: 100% !important;
          font-size: 0.8rem;
        }
      }
      .btn-right {
        width: 100%;
        overflow: hidden;
        text-overflow: hidden;
        .add-favorite-3,
        .add-favorite-2,
        .add-favorite-1 {
          margin-top: 20px;
          width: 100% !important;
          font-size: 0.8rem;
        }
      }
    }
  }
}

@include desktop {
  .company_card {
    margin-bottom: 32px !important;
    height: auto;

    .img-description {
      .logo_box {
        width: 80px !important;
        min-width: 80px !important;
        height: 80px !important;
      }

      .box-company {
        padding-left: 20px;
        .company-name {
          font-weight: 600;
        }
        .company-info {
          height: 64px;
          line-height: 120%;
          white-space: pre-wrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .box-button {
      display: flex;
      justify-content: flex-start !important;
      align-items: flex-start !important;
      flex-direction: column !important;

      .btn-left {
        width: 100%;
        .com_btn {
          width: 100% !important;
        }
      }
      .btn-right {
        width: 100%;
        overflow: hidden;
        text-overflow: hidden;
        .add-favorite-3,
        .add-favorite-2,
        .add-favorite-1 {
          margin-top: 20px;
          width: 100% !important;
        }
      }
    }
  }
}

@include ultra {
  .company_card {
    margin-bottom: 32px !important;
    height: auto;

    .img-description {
      .logo_box {
        width: 80px !important;
        min-width: 80px !important;
        height: 80px !important;
      }

      .box-company {
        padding-left: 20px;
        .company-name {
          font-weight: 600;
        }
        .company-info {
          height: 64px;
          line-height: 120%;
          white-space: pre-wrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .box-button {
      display: flex;
      justify-content: flex-start !important;
      align-items: flex-start !important;
      flex-direction: column !important;

      .btn-left {
        width: 100%;
        .com_btn {
          width: 100% !important;
        }
      }
      .btn-right {
        width: 100%;
        overflow: hidden;
        text-overflow: hidden;
        .add-favorite-3,
        .add-favorite-2,
        .add-favorite-1 {
          margin-top: 20px;
          width: 100% !important;
        }
      }
    }
  }
}
</style>
